import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { MembershipSelectAction } from "../hooks";
import { PlanCta } from "./PlanCta";

interface Props {
  action: MembershipSelectAction;
  trackers: {
    plusTracker: () => void;
    premiumTracker: () => void;
  };
}

export const MobileCtas: FC<Props> = ({ action, trackers }) => {
  const { t } = useTranslation();
  const hasPlusCta = t(`planSelect.${action}.plus.cta`);

  return (
    <Flex
      align="center"
      direction="column"
      display={{ base: "flex", lg: "none" }}
      gap={4}
      w="full"
    >
      <PlanCta
        action={action}
        handleClick={trackers.premiumTracker}
        type="premium"
        variant="th-primary"
      />
      {hasPlusCta && <Text>{t("common.or")}</Text>}
      <PlanCta action={action} handleClick={trackers.plusTracker} type="plus" />
    </Flex>
  );
};
